import { useState } from 'react';

interface Props {
  packagesForm: any;
  setPackagesForm: any;
  validating: boolean;
  formValidations: any;
  setFormValidations: any;
}
function ContainerFields({
  packagesForm,
  setPackagesForm,
  validating,
  formValidations,
  setFormValidations,
}: Props) {
  return (
    <div id='container_fields'>
      <div className='row mt-4'>
        <div className='col-sm-12'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_container_number'
          >
            Container number{' '}
            <span
              className='text-danger fw-bold'
              style={{ marginLeft: '5px' }}
            >
              *
            </span>
          </label>
          <input
            className={`form-control ubbe-input ${
              packagesForm?.container_number ? 'highlighted-border' : ''
            }`}
            id='main_container_number'
            placeholder='1929293'
            autoComplete='new-password'
            maxLength={50}
            value={packagesForm?.container_number}
            onChange={(e) => {
              setPackagesForm({
                ...packagesForm,
                container_number: e.target.value,
              });
              setFormValidations({
                ...formValidations,
                container_number: e.target.value !== '',
              });
            }}
          />

          {validating &&
            (!packagesForm?.container_number ||
              packagesForm?.container_number === '') && (
              <div
                className='error_text'
                id='year_error'
              >
                Please provide a container number.
              </div>
            )}
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <label
            className='globalInputLabel pb-2'
            htmlFor='main_container_status'
          >
            Container Status
          </label>
          <select
            className={`form-select ubbe-input ${
              packagesForm?.status_name ? 'highlighted-border' : ''
            }`}
            id='main_container_status'
            data-width='100%'
            data-size='8'
            value={packagesForm?.status_name}
            onChange={(e) => {
              setPackagesForm({
                ...packagesForm,
                status_name: e.target.value,
              });
            }}
          >
            <option
              value='EMPT'
              selected
            >
              Empty
            </option>
            <option value='HALF'>Half Packed</option>
            <option value='FULL'>Full Packed</option>
          </select>
          <div
            className='invalid-feedback'
            id='main_anti_error'
          >
            Please select Anti-Theft.
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContainerFields;
